import script from "./Ichimoku.vue?vue&type=script&lang=js"
export * from "./Ichimoku.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__